/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, Card, Col, Row } from "antd";
import {
  InputNumberField,
  SelectField,
} from "../../../../../../atoms/FormFields";
import { FieldErrors, useFieldArray } from "react-hook-form";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../../../config/hooks";
import { getCompanyFieldsById } from "../../../../TagsCategories/ducks/actions";
import { SelectFieldTags } from "../../../../../../atoms/FormFields/SelectFieldTags";
import { getServiceFormData } from "../../../ducks/actions";
import MaterialList from "../../../EditService/AddServiceStep2/Tabs/materialList";
import EquipmentBox from "../../../EditService/AddServiceStep2/Tabs/equipmentBox";
import { ReverstIcon } from "../../../../../../atoms/CustomIcons";

// Define or import the FormValues type
interface FormValues {
  name: string;
  description?: string;
  frequency?: string;
  quantity_unit?: string;
  production_rate?: number;
  subcontractors?: string[];
}

interface materialDropDownType {
  label: string;
  options: { value: string; label: string; color?: string; type: string }[];
}

interface PropsType {
  control: any;
  watch: any;
  setValue: any;
  setLoading: (loading: boolean) => void;
  errors: FieldErrors<FormValues>;
  serviceType: string;
  type: string | null;
  companyId: string;
  combineDropDown: materialDropDownType[];
  addEquipment: boolean;
  takeOffType: string;
  unitHour: boolean;
  setUnitHour: React.Dispatch<React.SetStateAction<boolean>>;
  setCombineDropDown: React.Dispatch<
    React.SetStateAction<materialDropDownType[]>
  >;
  setAddEquipment: React.Dispatch<React.SetStateAction<boolean>>;
}

const subcontractorsList: { value: string; label: string }[] = [
  { value: "Weekly", label: "Weekly" },
  { value: "Bi-weekly", label: "Bi-weekly" },
  { value: "Monthly", label: "Monthly" },
  { value: "Quarterly", label: "Quarterly" },
];
interface CategoryType {
  label: string;
  value: string;
  color: string;
}
export default function LaborTab(props: PropsType) {
  const {
    control,
    serviceType,
    type,
    companyId,
    combineDropDown,
    addEquipment,
    setCombineDropDown,
    setAddEquipment,
    takeOffType,
    watch,
    unitHour,
    setUnitHour,
    setValue,
  } = props;
  const dispatch = useAppDispatch();
  const tagItems = useAppSelector((state) => state?.tags?.tagData);
  const [categoryDropDown, setCategoryDropDown] = useState<CategoryType[]>([]);
  const [laborRate, setLaborRate] = useState<number>(0);
  const serviceFormData = useAppSelector(
    (state) => state?.services?.serviceFormData
  );

  const { fields, append, remove } = useFieldArray({
    control,
    name: "materials",
  });

  useEffect(() => {
    if (companyId) {
      const payload = {
        company_id: companyId,
        module: "SERVICE",
      };

      dispatch(getCompanyFieldsById(payload));
      dispatch(getServiceFormData(companyId));
    }
  }, [dispatch, companyId]);

  useEffect(() => {
    if (tagItems?.data && tagItems?.data?.length > 0) {
      const dummyArray: CategoryType[] = [];
      tagItems?.data?.map((item: { name: string; id: string; color: string }) =>
        dummyArray.push({
          label: item?.name,
          value: item?.id,
          color: item?.color,
        })
      );
      setCategoryDropDown(dummyArray);
    } else {
      setCategoryDropDown([]);
    }
  }, [tagItems]);

  useEffect(() => {
    if (serviceFormData?.data) {
      const materialOptions = Array.isArray(serviceFormData?.data?.materials)
        ? serviceFormData?.data?.materials?.map((item: any) => ({
            label: item.label, // Material labels are normal strings
            value: item.value,
            unit: item?.unit,
            type: "material", // You can add this back if needed for other logic
          }))
        : [];

      // 2. Format the category options, rendering labels as Tags
      const categoryOptions = Array.isArray(serviceFormData?.data?.category)
        ? serviceFormData?.data?.category.map((item: any) => ({
            value: item.value,
            // Category labels are rendered as Tags
            label: item.label,
            color: item?.color,
            type: "category", // You can add this back if needed for other logic
          }))
        : [];

      // 3. Create the grouped structure
      const groupedSelectOptions = [
        {
          label: "Material categories:", // The header for the categories group
          options: categoryOptions, // The array of category options (with Tags)
        },
        {
          label: "Materials:", // The header for the materials group
          options: materialOptions, // The array of material options
        },
      ];

      setCombineDropDown(groupedSelectOptions);
    }
  }, [serviceFormData?.data, setCombineDropDown]);

  const laborReverst = () => {
    setUnitHour(!unitHour);
    const productionValue = watch("production_rate");
    if (unitHour && productionValue) {
      setValue("production_rate", 1 / productionValue);
    } else if (!unitHour && productionValue) {
      setValue("production_rate", laborRate);
    }
  };

  return (
    <div className="tabs_content">
      {type === "simple" ? (
        serviceType === "in_house" ? (
          <>
            <Card>
              <Row gutter={16}>
                <Col span={13}>
                  <h4 style={{ marginBottom: "4px" }}>Labor</h4>
                  <p>
                    Labor production rate is used to calculate the crew labor
                    direct cost.
                  </p>
                </Col>
                <Col
                  span={11}
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <div className="production_box" style={{ width: 112 }}>
                    <InputNumberField
                      fieldName="production_rate"
                      label="Production rate"
                      control={control}
                      iProps={{
                        placeholder: "Enter production rate",
                      }}
                      onInputChange={(e: number) => setLaborRate(e)}
                      price
                      className="bottom_0"
                    />
                  </div>

                  <div
                    className="mt_short"
                    style={{
                      marginTop: 8,
                      marginLeft: 10,
                      display: "flex",
                      alignItems: "center",
                      fontSize: 15,
                      lineHeight: "20px",
                      fontWeight: 400,
                      color: "#151718",
                    }}
                  >
                    {unitHour ? (
                      <>{takeOffType ?? "..."} / hr</>
                    ) : (
                      <> hrs / {takeOffType ?? "..."}</>
                    )}

                    <div
                      className="reverst_icon"
                      style={{ marginTop: 4, marginLeft: 4 }}
                    >
                      <Button
                        htmlType="button"
                        className="only_icon"
                        onClick={laborReverst}
                        icon={<ReverstIcon />}
                        style={{
                          width: 28,
                          height: 28,
                        }}
                      />
                    </div>
                  </div>
                </Col>
              </Row>
            </Card>
            <MaterialList
              control={control}
              append={append}
              watch={watch}
              remove={remove}
              fields={fields}
              combineDropDown={combineDropDown}
              takeOffType={takeOffType}
              setValue={setValue}
            />

            <EquipmentBox
              control={control}
              addEquipment={addEquipment}
              setAddEquipment={setAddEquipment}
              equipmentData={serviceFormData?.data?.equipments}
            />
          </>
        ) : (
          <Card>
            <div className="card_top">
              <div className="card_left">
                <h4>Subcontractors</h4>
                <p style={{ marginBottom: "16px" }}>
                  Vendors who can perform this service. Leave blank if it’s
                  defined during the estimation.
                </p>
              </div>
            </div>

            <SelectField
              fieldName="subcontractors"
              label="Subcontractors"
              control={control}
              selectOption={subcontractorsList}
              iProps={{
                placeholder: "Select subcontractors",
              }}
            />
          </Card>
        )
      ) : (
        <Card>
          <div className="card_top">
            <div className="card_left">
              <h4
                style={{
                  marginBottom: "4px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                }}
              >
                Subservice categories
              </h4>
              <p style={{ marginBottom: "16px" }}>
                In services with many subservices, you can group them for
                convenience (optional). For example, all tree and shrub planting
                subservices can be grouped as “Planting”.
              </p>
              <SelectFieldTags
                fieldName="category_ids"
                label=""
                control={control}
                selectOption={categoryDropDown}
                iProps={{
                  placeholder: "Select categories",
                }}
              />
              <div className="whenEmpty">
                <h3> There are no categories </h3>
                <p> To add one, enter a its name to the field above. </p>
              </div>
            </div>
          </div>
        </Card>
      )}
    </div>
  );
}
